module.exports = __webpack_public_path__ + "static/media/004-sad.acfd2d8c.svg";